export const CREATE_MODULE_ACTION = '[Module Action] Create Module';
export const CONFIRMED_CREATE_MODULE_ACTION = '[Module Action] Confirmed Create Module';
export const CREATE_MODULE_ERROR_ACTION='[Module Action] Create Module Error';
export const GET_MODULES = '[Module Action] Get Modules';
export const CONFIRMED_GET_MODULES = '[Module Action] Confirmed Get Modules';
export const LOADING_MODULES = '[Module Action] Loading for Modules';
export const EDIT_MODULE_ACTION = '[Module Action] Edit Module';
export const CONFIRMED_EDIT_MODULE_ACTION = '[Module Action] Confirmed Edit Module';
export const DELETE_MODULE_ACTION = '[Module Action] Delete Module';
export const CONFIRMED_DELETE_MODULE_ACTION = '[Module Action] Confirmed Delete Module';
export const MODULE_ERROR_ACTION = '[Module Action] Error';
export const CLEAR_MODULE_ERROR = '[Module Action] Clear Error';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';



